"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCancellationPolicyDescription = void 0;
var _localization = require("@lt/localization");
var _date = require("../../../utils/date");
var _userflow = require("../../../constants/userflow");
var getCancellationPolicyDescription = exports.getCancellationPolicyDescription = function getCancellationPolicyDescription(returnType, endDate, refundAmount) {
  if (returnType === 'full') return "".concat(_localization.i18n.t('cancellationPolicy.tariff.full'), " ").concat(_localization.i18n.t('cancellationPolicy.tariff.before'), " ").concat((0, _date.formatDate)(endDate, 'd MMM, HH:mm'), " - ").concat(refundAmount).concat(_userflow.NBSP, "\u20BD");
  if (returnType === 'nothing') return _localization.i18n.t('cancellationPolicy.tariff.nothing');
  if (returnType === 'partial') return "".concat(_localization.i18n.t('cancellationPolicy.tariff.partial'), " ").concat(_localization.i18n.t('cancellationPolicy.tariff.before'), " ").concat((0, _date.formatDate)(endDate, 'd MMM, HH:mm'), " - ").concat(refundAmount).concat(_userflow.NBSP, "\u20BD");
  return '';
};